import React, { useState } from 'react'
import './Navbar.css';
import { Link } from 'react-router-dom'
import { assets } from '../../assets/assets';
import { useSelector } from 'react-redux';
function Navbar({setShowLogin}) {
    const [menu,setMenu]=useState("Home")
    const cartItems = useSelector((state) => {
        return state;
      });
      console.log(cartItems)
  return (
    <nav>
    <div className='container'>
        <div className='d-flex justify-content-between align-items-center py-2'>
            <div className='logo'>
                <img src={assets.logo} alt=''/>
            </div>
            <ul className='navbar-menu-list'>
                <li onClick={()=>setMenu("Home")} className={menu==="Home" ? "active" : ""}><Link to='/'>Home</Link></li>
                <li onClick={()=>setMenu("Menu")} className={menu==="Menu" ? "active" : ""}><a href='#menu'>Menu</a></li>
                <li onClick={()=>setMenu("Mobile-app")} className={menu==="Mobile-app" ? "active" : ""}><a href='#mobile-app'>Mobile-app</a></li>
                <li onClick={()=>setMenu("Contact-us")} className={menu==="Contact-us" ? "active" : ""}><a href='#footer'>Contact-us</a></li>
            </ul>
            <div className='navbar-right'>
                <div>
                    <img src={assets.search_icon} alt='serach'/>
                </div>
                <Link to='/cart' className='basket'>
                    <img src={assets.basket_icon} alt='serach'/>
                    <span className='dot'>{Object.keys(cartItems).length}</span>
                </Link>
                <button className='nav-btn' onClick={()=>setShowLogin(true)}>Sign In</button>
            </div>
        </div>
    </div>
    </nav>
  )
}

export default Navbar